import { InformationCircleIcon } from "@heroicons/react/24/outline";

/**
 * Pressable info icon for calculation / methodology dialogs.
 */
export const CalculationInfoIcon = ({
  onClick,
  ariaLabel,
  className = "",
  iconClassName = "h-4 w-4",
}) => {
  if (!onClick) return null;

  const stopParentActivation = (e) => {
    e.stopPropagation();
  };

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      onKeyDown={stopParentActivation}
      onKeyUp={stopParentActivation}
      aria-label={ariaLabel}
      className={`inline-flex shrink-0 items-center justify-center rounded p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${className}`}
    >
      <InformationCircleIcon className={iconClassName} aria-hidden="true" />
    </button>
  );
};

export default CalculationInfoIcon;
